"use client";

import React from "react";
import { Box, Map, Leaf } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Skills Development",
  description: "Practical, accredited and targeted training that builds workplace-ready skills and creates pathways to opportunity.",
  icon: Box
}, {
  title: "Social Facilitation",
  description: "Stakeholder engagement, community mobilisation and facilitation that connects projects with the people and communities they serve.",
  icon: Map
}, {
  title: "Community Development",
  description: "People-centred initiatives that strengthen participation, improve livelihoods and support sustainable community development.",
  icon: Leaf
}];
export default function PourquoiBoxify() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224452" id="new-bpo-solutions" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden relative">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/graphy-dark.png')]" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-6 text-foreground">What We Do</h2>
          <Separator className="w-24 h-1 bg-secondary rounded-lg" />
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full bg-card/40 backdrop-blur-xl border-white/10 shadow-xl hover:shadow-secondary/20 transition-all duration-300 flex flex-col items-center text-center group border-t-2 border-t-secondary/30">
                  <CardHeader className="pt-10 pb-4 flex flex-col items-center gap-4">
                    <div className="relative">
                      <div className="p-4 rounded-lg bg-secondary/10 text-secondary mb-2 transition-colors duration-300 group-hover:bg-secondary/20">
                        <Icon size={48} strokeWidth={1.5} />
                      </div>
                      
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl font-bold tracking-tight text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-10 px-8">
                    <p className="font-default text-muted-foreground leading-relaxed text-base">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}